<template>
  <AppModal
    :value="value"
    @input="onInput"
    :title="isEdit ? 'Editar configuración de servicio' : 'Agregar configuración de servicio'">
    <form @submit.prevent="onSubmit" class="store-shipping-service-form">
      <AppField
        label="Servicio"
        required
        :state="errors.serviceId === null ? null : !errors.serviceId"
        :invalidFeedback="errors.serviceId">
        <AppSelect
          v-model="form.serviceId"
          :options="serviceOptions"
          :disabled="isEdit">
          <option value="" disabled>Seleccionar servicio</option>
        </AppSelect>
      </AppField>

      <AppField
        label="Región"
        required
        :state="errors.regionId === null ? null : !errors.regionId"
        :invalidFeedback="errors.regionId">
        <AppSelect
          v-model="form.regionId"
          :options="regionOptions"
          :disabled="isEdit">
          <option value="" disabled>Seleccionar región</option>
        </AppSelect>
      </AppField>

      <AppField
        label="Precio (CLP)"
        required
        :state="errors.price === null ? null : !errors.price"
        :invalidFeedback="errors.price">
        <AppInput
          type="number"
          v-model.number="form.price"
          placeholder="0"
          min="0" />
      </AppField>

      <AppField label="Activo">
        <AppCheckbox v-model="form.isActive">
          Servicio disponible para esta tienda en esta región
        </AppCheckbox>
      </AppField>

      <div v-if="submitError" class="store-shipping-service-form__alert">
        {{ submitError }}
      </div>

      <div class="store-shipping-service-form__actions">
        <AppButton outline type="button" @click="close">
          Cancelar
        </AppButton>
        <AppButton type="submit" :disabled="loading">
          <span v-if="loading">Guardando...</span>
          <span v-else>{{ isEdit ? 'Actualizar' : 'Agregar' }}</span>
        </AppButton>
      </div>
    </form>
  </AppModal>
</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '../UI/AppModal.vue'
import AppField from '../UI/AppField.vue'
import AppInput from '../UI/AppInput.vue'
import AppSelect from '../UI/AppSelect.vue'
import AppButton from '../UI/AppButton.vue'
import AppCheckbox from '../UI/AppCheckbox.vue'

export default {
  name: 'StoreShippingServiceForm',
  components: { AppModal, AppField, AppInput, AppSelect, AppButton, AppCheckbox },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    storeId: {
      type: Number,
      required: true
    },
    config: {
      type: Object,
      default: null
    },
    services: {
      type: Array,
      default: () => []
    },
    regions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      form: {
        serviceId: '',
        regionId: '',
        isActive: false,
        price: null
      },
      errors: {
        serviceId: null,
        regionId: null,
        price: null
      },
      submitError: '',
      loading: false
    }
  },
  computed: {
    isEdit () {
      return !!(this.config && this.config.id)
    },
    serviceOptions () {
      return (this.services || []).map(s => ({
        value: s.id,
        text: `${s.name} (${s.code})`
      }))
    },
    regionOptions () {
      return (this.regions || []).map(r => ({
        value: r.id,
        text: r.name
      }))
    }
  },
  watch: {
    value (isOpen) {
      if (isOpen) this.reset()
    }
  },
  methods: {
    ...mapActions(['upsertStoreShippingConfig']),
    onInput (val) {
      this.$emit('input', val)
    },
    close () {
      this.$emit('input', false)
    },
    reset () {
      this.submitError = ''
      this.loading = false
      this.errors = { serviceId: null, regionId: null, price: null }
      if (this.isEdit) {
        this.form = {
          serviceId: this.config.serviceId,
          regionId: this.config.regionId,
          isActive: !!this.config.isActive,
          price: this.config.price
        }
      } else {
        this.form = {
          serviceId: '',
          regionId: '',
          isActive: false,
          price: null
        }
      }
    },
    validate () {
      this.errors = { serviceId: null, regionId: null, price: null }
      let valid = true

      if (!this.form.serviceId) {
        this.errors.serviceId = 'Debe seleccionar un servicio'
        valid = false
      }
      if (!this.form.regionId) {
        this.errors.regionId = 'Debe seleccionar una región'
        valid = false
      }
      if (this.form.isActive && (!this.form.price || this.form.price <= 0)) {
        this.errors.price = 'Debe indicar un precio mayor a 0 para activar el servicio'
        valid = false
      }
      return valid
    },
    async onSubmit () {
      this.submitError = ''
      if (!this.validate()) return

      this.loading = true
      try {
        const payload = {
          serviceId: Number(this.form.serviceId),
          regionId: Number(this.form.regionId),
          isActive: !!this.form.isActive,
          price: this.form.price === null || this.form.price === undefined || this.form.price === ''
            ? null
            : Number(this.form.price)
        }
        const response = await this.upsertStoreShippingConfig({ storeId: this.storeId, config: payload })
        if (response && response.status === 200) {
          this.$emit('saved', response.data)
          this.close()
        } else if (response && response.data && response.data.error) {
          this.submitError = response.data.error
        } else {
          this.submitError = 'No se pudo guardar la configuración'
        }
      } catch (err) {
        this.submitError = (err && err.response && err.response.data && err.response.data.error)
          || (err && err.message)
          || 'Error inesperado'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.store-shipping-service-form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.store-shipping-service-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
}

.store-shipping-service-form__alert {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: #fee2e2;
  color: #991b1b;
  border-radius: 4px;
  font-size: 0.875rem;
}
</style>